/**
 * BX Widget Addon Row Toggle
 * Automatically limits .bx-addon-row to 4 items and adds a "Show more / Show less" toggle button.
 */
(() => {
  const MAX_VISIBLE = 4;

  function initToggleForContainer(container) {
    const list = container.querySelector('.bx-addon-list, .bx-extras');
    if (!list) return;

    const rows = Array.from(list.querySelectorAll('.bx-addon-row'));
    let toggleBtn = container.querySelector('.bx-addon-toggle-btn');

    if (rows.length <= MAX_VISIBLE) {
      // If rows are 4 or fewer, make sure all are visible and remove toggle button if it exists
      rows.forEach((row) => row.classList.remove('bx-addon-row--hidden'));
      if (toggleBtn) toggleBtn.remove();
      return;
    }

    // Check current state (default to collapsed if not already set)
    const isExpanded = toggleBtn ? toggleBtn.getAttribute('aria-expanded') === 'true' : false;
    const hiddenCount = rows.length - MAX_VISIBLE;

    // Apply visibility class
    rows.forEach((row, index) => {
      if (index >= MAX_VISIBLE && !isExpanded) {
        row.classList.add('bx-addon-row--hidden');
      } else {
        row.classList.remove('bx-addon-row--hidden');
      }
    });

    // Create toggle button if not already created
    if (!toggleBtn) {
      toggleBtn = document.createElement('button');
      toggleBtn.type = 'button';
      toggleBtn.className = 'bx-addon-toggle-btn';
      toggleBtn.setAttribute('aria-expanded', 'false');

      toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !currentExpanded;

        toggleBtn.setAttribute('aria-expanded', String(nextExpanded));

        const currentRows = Array.from(list.querySelectorAll('.bx-addon-row'));
        currentRows.forEach((row, idx) => {
          if (idx >= MAX_VISIBLE) {
            row.classList.toggle('bx-addon-row--hidden', !nextExpanded);
          }
        });

        updateButtonContent(toggleBtn, nextExpanded, currentRows.length - MAX_VISIBLE);
      });

      // Insert button right after the addon list
      list.insertAdjacentElement('afterend', toggleBtn);
    }

    updateButtonContent(toggleBtn, isExpanded, hiddenCount);
  }

  function updateButtonContent(button, isExpanded, hiddenCount) {
    const chevronSvg = `
      <svg class="bx-addon-toggle-icon" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    `;

    if (isExpanded) {
      button.innerHTML = `
        <span class="bx-addon-toggle-text">Show less</span>
        ${chevronSvg}
      `;
      button.classList.add('is-expanded');
    } else {
      button.innerHTML = `
        <span class="bx-addon-toggle-text">Show more (+${hiddenCount})</span>
        ${chevronSvg}
      `;
      button.classList.remove('is-expanded');
    }
  }

  function checkAllWidgets() {
    const containers = document.querySelectorAll('.bx-widget-container');
    containers.forEach((container) => initToggleForContainer(container));
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAllWidgets);
  } else {
    checkAllWidgets();
  }

  // Observe dynamically loaded widgets (Shopify apps inject after DOM load or on variant change)
  let debounceTimer = null;
  const observer = new MutationObserver(() => {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      checkAllWidgets();
    }, 100);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
